import { Modal, Alert } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const AppVersionModal = ({ visible, onConfirm }) => {
  return (
    <Modal
      open={visible}
      closable={false}
      maskClosable={false}
      footer={null}
      centered
      width={450}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <ExclamationCircleOutlined
          style={{ fontSize: "49px", color: "#faad14", marginBottom: "16px" }}
        />
        <h2 style={{ marginBottom: "16px" }}>Actualización Disponible</h2>
        <Alert
          message="Nueva versión del WMS detectada"
          description="Se ha desplegado una nueva versión del sistema. Es necesario renovar la sesión y limpiar la caché para continuar operando con las últimas mejoras."
          type="warning"
          showIcon
          style={{ marginBottom: "24px", textAlign: "left" }}
        />
        <p style={{ color: "#666", marginBottom: "24px" }}>
          Al hacer clic en "Actualizar", se cerrará tu sesión actual y la página
          se recargará automáticamente.
        </p>
        <button
          onClick={onConfirm}
          style={{
            backgroundColor: "#FB9A1A",
            borderColor: "#FB9A1A",
            color: "white",
            border: "none",
            padding: "12px 32px",
            borderRadius: "6px",
            fontSize: "17px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Actualizar
        </button>
      </div>
    </Modal>
  );
};

export default AppVersionModal;
